<script>
    const axios = require('axios');

    export default {

        data() {
            return {
                subscribed: false,
                errors: null,
            }
        },

        methods: {

            subscribe() {
                axios.post('/newsletter/subscribe')
                .then(response => {
                    this.subscribed = true
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
            }

        }
    };
</script>